<template>
  <div class="col-md-12 mb-5">
    <b-form>
      <div class="row">
        <b-input
          placeholder="Tìm kiếm"
          v-model="searchKeyword"
          append-icon="keyword"
          single-line
          hide-details
          class="col-md-4 btn-sm"
          v-on:input="onInputChange"
        ></b-input>
        <div
          class="col-md-8"
          style="padding-right: 0px"
        >
          <div class="d-flex justify-content-end"></div>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import decounce from 'debounce';

export default {
  name: 'SearchBar',
  props: {
    initialKeyword: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      searchKeyword: this.initialKeyword,
    };
  },
  watch: {
    initialKeyword(newValue) {
      this.searchKeyword = newValue;
    },
  },
  methods: {
    onInputChange() {
      this.debounceInput();
    },
    debounceInput: decounce(function () {
      this.$emit('search', this.searchKeyword);
    }, 500),
  },
};
</script> 
